import { useState } from "react";
import { requestUploadUrl, PostFileIn } from "../api/posts";

export function useS3Upload() {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");

  async function uploadFile(file: File): Promise<PostFileIn> {
    setError("");
    setUploading(true);
    setProgress(0);
    try {
      // Step 1: get presigned URL from backend
      const presign = await requestUploadUrl(file.name, file.type, file.size);

      // Step 2: direct upload to S3 via multipart POST
      const formData = new FormData();
      for (const [k, v] of Object.entries(presign.fields)) {
        formData.append(k, v);
      }
      formData.append("file", file);

      const response = await fetch(presign.upload_url, {
        method: "POST",
        body: formData,
      });

      // S3 returns 204 No Content on success (or 201 with policy)
      if (!response.ok && response.status !== 204) {
        throw new Error(`Загрузка не удалась (HTTP ${response.status})`);
      }

      setProgress(100);
      return {
        s3_key: presign.s3_key,
        original_filename: file.name,
        mime_type: file.type,
        size_bytes: file.size,
        sort_order: 0, // caller will renumber
      };
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : "Ошибка загрузки";
      setError(msg);
      throw e;
    } finally {
      setUploading(false);
    }
  }

  return { uploadFile, uploading, progress, error };
}
